"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
var react_1 = __importDefault(require("react"));
// Relements
var box_1 = __importDefault(require("relements/build/esm/ui/box"));
var text_1 = __importDefault(require("relements/build/esm/ui/text"));
var StyledComponets_1 = require("./StyledComponets");
var ActionCard = function (_a) {
    var title = _a.title, _b = _a.description, description = _b === void 0 ? '' : _b, _c = _a.onDelete, onDelete = _c === void 0 ? null : _c, _d = _a.onConfigure, onConfigure = _d === void 0 ? null : _d, _e = _a.id, id = _e === void 0 ? '' : _e;
    return (react_1["default"].createElement(StyledComponets_1.StyledActionCard, { borderRadius: "md", display: "grid", width: "inherit" },
        react_1["default"].createElement(box_1["default"], { padding: "0", style: { gap: '8px' } },
            react_1["default"].createElement(text_1["default"], { variant: "h3.semi-bold", color: "black.haptik" }, title),
            title === 'Break' && (react_1["default"].createElement(text_1["default"], { variant: "h3.semi-bold", color: "grey.dark" }, "(Predefined Action)"))),
        description && (react_1["default"].createElement(StyledComponets_1.StyledText, { marginBottom: "16px" }, description)),
        react_1["default"].createElement(box_1["default"], { padding: "0", display: "flex", justifyContent: "flex-end", style: { gap: '16px' } },
            !(title === 'Break') && onDelete && (react_1["default"].createElement(text_1["default"], { variant: "h3.semi-bold", color: "red.haptik", style: { cursor: 'pointer' }, onClick: function () {
                    onDelete(id);
                } }, "Delete")),
            onConfigure && (react_1["default"].createElement(text_1["default"], { variant: "h3.semi-bold", color: "blue.haptik", style: { cursor: 'pointer' }, onClick: function () {
                    onConfigure(id);
                } }, "Configure")))));
};
exports["default"] = ActionCard;
